// import { Component, Vue, Prop, Watch, Inject } from 'vue-property-decorator';
import { computed, defineComponent } from 'vue';
import CurveLine from './curve-line.vue';
// import { IDayList, IUMC } from '@blade-sxp/monitor/interfaces/queue';
export default defineComponent({
    name: 'ChartTotal',
    i18n: {
        messages: {
            'en-us': {
                currentNumber: 'Current Queuing Number',
                people: 'ppl',
            },
            zh: {
                currentNumber: '当前总排队人数',
                people: '人',
            },
        },
    },
    components: {
        'curve-line': CurveLine,
    },
    props: {
        daySummary: Array,
    },
    setup(props, ctx) {
        const total = computed(() => props.daySummary[0]?.queueingCountHistoryList || []);
        const queueingCount = computed(() => props.daySummary[0]?.queueingCount);
        return {
            total,
            queueingCount,
        };
    },
});
// @Component({
//   name: 'ChartTotal',
//   components:{'curve-line': CurveLine},
//    i18n: {
//     messages: {
//       'en-us': {
//         currentNumber:'Current Queuing Number '
//       },
//       zh: {
//         currentNumber:'当前总排队人数'
//       },
//     },
//     }
// })
// export default class extends Vue {
// @Prop() readonly numData!: IUMC
// @Prop()
// daySummary!: Array<IUMC>;
// setup(props: any, ctx: any){
// }
// get total(){
//   const res = this.daySummary[0]?.queueingCountHistoryList || [];
//   return res;
// }
// get queueingCount(){
//   return this.daySummary[0]?.queueingCount?? 0;
// }
// mounted() {
// }
// }
